<template>
  <footer class="staff-footer">
    <div class="staff-footer-main">
      <div class="staff-footer-inner">
        <div class="staff-footer-brand">
          <img :src="logoSrc || '/figma/logo.svg'" alt="" width="52" height="52">
          <strong>{{ siteConfig && siteConfig.footerTitle || '科学教育创新成果展示大赛' }}</strong>
        </div>
        <p>{{ siteConfig && siteConfig.footerDescription || '面向广东省中小学生的赛事报名、作品提交与成果展示服务平台。' }}</p>
        <div class="staff-footer-service">
          <span>服务时间：{{ siteConfig && siteConfig.serviceHours || '工作日 09:00–18:00' }}</span>
          <span>赛事咨询：{{ siteConfig && siteConfig.consultationText || '以组委会最新公告为准' }}</span>
        </div>
        <router-link class="student-entry" to="/"><i></i>学生端报名</router-link>
      </div>
    </div>
    <div class="staff-footer-copyright">© {{ year }} {{ siteConfig && siteConfig.copyrightName || '广东省中小学生科学教育创新成果展示大赛' }}</div>
  </footer>
</template>

<script>
export default {
  name: 'StaffFooter',
  props: {
    siteConfig: { type: Object, default: null },
    logoSrc: { type: String, default: '' },
  },
  computed: { year() { return new Date().getFullYear() } },
}
</script>

<style scoped lang="less">
.staff-footer{background:linear-gradient(115deg,#101e39,#172d53);color:#fff}.staff-footer-main{height:182px}.staff-footer-inner{max-width:1440px;width:calc(100% - 48px);height:100%;margin:0 auto;display:grid;grid-template-columns:330px 1fr 280px 160px;align-items:center;gap:34px}.staff-footer-brand{display:flex;align-items:center;gap:13px}.staff-footer-brand img{box-sizing:border-box;padding:2px;border-radius:50%;background:#fff;object-fit:contain}.staff-footer-brand strong{font-size:16px;line-height:26px}.staff-footer-inner p{margin:0;color:#90a3c4;font-size:14px;line-height:26px}.staff-footer-service{display:flex;flex-direction:column;gap:11px;color:#90a3c4;font-size:13px;line-height:20px}.student-entry{display:flex;align-items:center;justify-content:flex-end;gap:12px;color:#a9b8d1;font-size:14px}.student-entry i{width:0;height:0;border-top:8px solid transparent;border-bottom:8px solid transparent;border-left:12px solid #9dadc6}.student-entry:hover{color:#fff}.staff-footer-copyright{box-sizing:border-box;height:60px;border-top:1px solid rgba(255,255,255,.09);padding:22px max(24px,calc((100% - 1440px)/2));color:#7187ad;font-size:13px}
@media(max-width:1100px){.staff-footer-inner{grid-template-columns:280px 1fr 250px;gap:24px}.student-entry{display:none}}
@media(max-width:760px){.staff-footer-main{height:auto}.staff-footer-inner{width:calc(100% - 32px);padding:30px 0;grid-template-columns:1fr;gap:18px}.staff-footer-brand img{width:44px;height:44px}.staff-footer-inner p{font-size:13px}.staff-footer-service{font-size:12px}.staff-footer-copyright{height:auto;padding:18px 16px;font-size:11px}}
</style>
